import * as React from "react";
import ImageHybrid from "./ImageHybrid";
import type { TypeImageProps } from "./ImageTypes";

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

/**
 * Image component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or a styled() extension). The load/error state lives in
 * ImageHybrid so behavior is identical on both paths.
 */
const Image = (props: TypeImageProps) => <ImageHybrid {...props} />;

// Preserve the original public type surface: defaultProps keep title/onError/
// onClick/onLoad optional at the JSX call site (these are required in
// TypeImageProps). The defaults are applied before reaching ImageHybrid.
Image.defaultProps = {
  title: "",
  onError: noop,
  onClick: noop,
  onLoad: noop,
};

export default Image;
